export default __webpack_public_path__ + "static/media/mobile-alt-solid.29c21978.svg";